import { formatCurrency } from '../utilities/_commerce'
import { pushGa4Event } from '../utilities/_analytics'

export function contactForm () {
	return {
		form: { firstName: '', lastName: '', phoneNumber: '', emailAddress: '', company: '', role: '', streetAddress: '', city: '', county: '', country: '', postcode: '', agreeTerms: false},
		errors: {}, notice: '', loading: false,

		init () {
			pushGa4Event('enquiry_step_view', {
				enquiry_step_name: 'contact details',
				enquiry_step_number: 3
			})
		},

		hasField (selector) {
			return Boolean(this.$refs.form?.querySelector(selector));
		},

		validate () {
			this.errors = {};

			// Simple client-side checks (mirror Craft rules where sensible)
			if (this.hasField('#firstName') && !this.form.firstName) {
				this.errors.firstName = 'Please enter you first name';
			}
			if (this.hasField('#lastName') && !this.form.lastName) {
				this.errors.lastName = 'Please enter you last name';
			}
			if (this.hasField('#phone') && !this.form.phoneNumber) {
				this.errors.phoneNumber = 'Phone number is required';
			}
			if (this.hasField('#emailAddress') && (!this.form.emailAddress || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.emailAddress))) {
				this.errors.emailAddress = 'Enter a valid email address.';
			}
			if (this.hasField('#company') && !this.form.company) {
				this.errors.company = 'Company is required';
			}
			if (this.hasField('#role') && !this.form.role) {
				this.errors.role = 'Job role is required';
			}
			// Billing fields (guest and logged-in-without-account-address use billingAddress[*] names; IDs differ)
			const billingLine1 = '[name="billingAddress[addressLine1]"]'
			const billingLocality = '[name="billingAddress[locality]"]'
			const billingAdminArea = '[name="billingAddress[administrativeArea]"]'
			const billingPostcode = '[name="billingAddress[postalCode]"]'
			const billingCountry = '[name="billingAddress[countryCode]"]'

			if (this.hasField(billingLine1) && !this.form.streetAddress) {
				this.errors.streetAddress = 'Street address is required';
			}
			if (this.hasField(billingLocality) && !this.form.city) {
				this.errors.city = 'City is required';
			}
			if (this.hasField(billingAdminArea) && !this.form.county) {
				this.errors.county = 'County is required';
			}
			if (this.hasField(billingCountry) && !this.form.country) {
				this.errors.country = 'Country is required';
			}
			if (this.hasField(billingPostcode) && !this.form.postcode) {
				this.errors.postcode = 'Post code is required';
			}
			if (this.hasField('#agreeTerms') && !this.form.agreeTerms) {
				this.errors.agreeTerms = 'Please confirm you accept our terms and conditions';
			}

			return Object.keys(this.errors).length === 0;
		},

		async submit (e) {
			e.preventDefault()
			if (this.loading) return;
			this.notice = '';
			this.errors = {};

			if (!this.validate()) return;

			this.loading = true;
			pushGa4Event('enquiry_step_submit', {
				enquiry_step_name: 'contact details',
				enquiry_step_number: 3
			})
			// Submit natively so Craft can handle redirects and flash messages.
			if (this.$refs.form && typeof this.$refs.form.submit === 'function') {
				HTMLFormElement.prototype.submit.call(this.$refs.form);
				return;
			}

			e.target.submit();
		},

		getLineItemPrice(price, salePrice, qty) {
			if (salePrice) {
				return formatCurrency(salePrice * qty)
			} else {
				return formatCurrency(price * qty)
			}
		},

		getTotal(price) {
			return formatCurrency(this.$store.cart.totalPrice)
		}
	}
}
